import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEnvironment } from '../../../hooks/useEnvironment';
import { betaLogo, devLogo, valSandboxLogo, validateLogo } from './logos';
import React from 'react';

const logos: Record<string, React.FC<SvgIconProps>> = {
  'verify-beta': betaLogo,
  'val-sandbox': valSandboxLogo,
  'verify-dev': devLogo,
  'verify-val': validateLogo,
};

const GVIconText = (props: SvgIconProps) => {
  const flags = useFlags();
  const showBetaLogo = flags?.showBetaLogo || false;
  const environment = useEnvironment();

  const logoKey = showBetaLogo ? 'verify-beta' : environment;
  const LogoComponent = logoKey ? logos[logoKey] : null;

  if (LogoComponent) {
    return <LogoComponent {...props} />;
  }

  return (
    <SvgIcon {...props} viewBox="0 0 1369 187">
      <path
        d="M350.858 35.0146L304.567 150.949H288.953L242.523 35.0146H265.565L296.829 117.129L327.92 35.0146H350.858Z"
        fill="white"
      />
      <path
        d="M345.775 110.255C345.775 88.9061 358.246 67.2461 385.986 67.2461C414.694 67.2461 423.986 90.3225 423.986 108.701C424.061 111.347 423.805 113.993 423.226 116.577H366.952C368.679 127.355 374.586 134.575 387.472 134.575C395.012 134.791 402.248 131.593 407.163 125.87L420.981 137.926C412.551 147.652 400.199 153.079 387.334 152.712C359.075 152.608 345.775 132.226 345.775 110.255ZM404.261 102.033C404.309 100.294 404.088 98.5577 403.604 96.8861C401.566 88.4225 394.519 84.0697 385.814 84.0697C373.999 84.0697 368.817 91.7734 366.952 102.033H404.261Z"
        fill="white"
      />
      <path
        d="M440.709 68.9722H460.262V82.7904C463.566 73.4921 472.365 67.2801 482.233 67.2795C487.826 67.1829 493.23 69.3071 497.26 73.1868L488.14 89.5959C485.503 87.7924 482.387 86.818 479.193 86.7977C469.831 86.7977 460.089 95.5032 460.089 116.369V150.914H440.709V68.9722Z"
        fill="white"
      />
      <path
        d="M517.831 27.2119L532.939 41.8023L518.349 56.911L503.24 42.3207L517.831 27.2119ZM508.072 68.9724H528.108V150.949H508.072V68.9724Z"
        fill="white"
      />
      <path
        d="M556.746 85.7281H541.719V68.9735H556.919V57.9881C556.919 42.0626 569.321 33.2881 583.104 33.2881C588.243 33.3874 593.304 34.5643 597.959 36.7426L591.395 53.2554C589.474 52.0087 587.257 51.2935 584.97 51.1826C580.962 51.1826 577.439 53.739 577.439 60.1299V69.0772H596.542V85.8317H577.473V151.054H556.746V85.7281Z"
        fill="white"
      />
      <path
        d="M632.161 148.739L600.068 68.9736H622.074L642.801 125.939L663.805 68.9736H685.776L638.932 186.255H617.099L632.161 148.739Z"
        fill="white"
      />
      <path
        d="M186.834 93.417L93.417 186.835L0 93.417L93.417 0L186.834 93.417ZM44.5225 93.417L93.416 142.312L142.311 93.417L93.416 44.5234L44.5225 93.417Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#paint0_linear_prod)"
      />
      <g filter="url(#filter0_prod)">
        <rect
          x="22.6289"
          y="115.897"
          width="30.8511"
          height="31.7414"
          transform="rotate(-45 22.6289 115.897)"
          fill="#EA3632"
        />
      </g>
      <g filter="url(#filter1_prod)">
        <rect
          x="142.459"
          y="93.8301"
          width="31.3673"
          height="31.129"
          transform="rotate(-45 142.459 93.8301)"
          fill="#EA3632"
        />
      </g>
      <path
        d="M187 93.613L164.765 71.378L93.6126 142.53L44.6956 93.613L22.4605 115.848L93.6126 187L187 93.613Z"
        fill="#EA3632"
      />
      <path
        d="M765.506 152.389C731.639 152.389 713.543 127.984 713.543 92.374C713.543 56.5977 731.722 32.7744 766.419 32.7744C789.578 32.7744 804.769 43.0674 812.986 63.8193L805.267 66.8906C798.958 48.6289 786.341 40.5771 766.336 40.5771C736.868 40.5771 721.678 60.333 721.678 92.042C721.678 121.593 734.627 144.503 765.506 144.503C785.013 144.503 797.796 135.953 805.516 117.94L813.152 121.012C804.021 141.598 788.167 152.389 765.506 152.389Z"
        fill="white"
      />
      <path
        d="M863.956 152.389C840.963 152.389 824.694 133.629 824.694 109.557C824.694 85.8164 840.963 67.1396 863.956 67.1396C886.867 67.1396 903.468 85.8164 903.468 109.557C903.468 133.463 886.867 152.389 863.956 152.389ZM863.956 145.416C882.882 145.416 895.333 129.562 895.333 109.557C895.333 89.7178 882.882 74.1123 863.956 74.1123C845.114 74.1123 832.912 89.6348 832.912 109.557C832.912 129.645 845.114 145.416 863.956 145.416Z"
        fill="white"
      />
      <path
        d="M924.638 151.227L924.555 68.3018H932.275V84.0732C936.592 72.9502 946.054 67.1396 958.091 67.1396C971.206 67.1396 980.669 73.4482 984.072 86.7295C988.305 74.1123 998.598 67.1396 1011.71 67.1396C1031.22 67.1396 1039.85 80.7529 1039.85 103.248V151.227H1031.97V104.078C1031.97 84.5713 1025.66 74.5273 1010.3 74.5273C995.61 74.5273 986.23 85.3184 986.23 100.924V151.227H978.345V100.26C978.345 83.9902 971.372 74.5273 956.762 74.5273C941.904 74.5273 932.524 85.3184 932.524 100.924V151.227H924.638Z"
        fill="white"
      />
      <path
        d="M1066.17 185.592V68.3018H1074.22V89.9668C1079.2 76.0215 1091.49 67.1396 1106.01 67.1396C1128.09 67.1396 1140.96 86.1484 1140.96 109.889C1140.96 133.546 1128.09 152.389 1105.93 152.389C1091.32 152.389 1079.2 143.424 1074.22 129.645V185.592H1066.17ZM1104.35 145.084C1122.78 145.084 1133.07 129.728 1133.07 109.889C1133.07 89.8838 1122.78 74.5273 1104.35 74.5273C1085.93 74.5273 1073.64 89.7178 1073.64 109.889C1073.64 129.894 1085.93 145.084 1104.35 145.084Z"
        fill="white"
      />
      <path
        d="M1189.94 67.1396C1210.69 67.1396 1222.06 79.4248 1222.06 100.426V151.227H1215.34L1214.84 132.55C1208.2 145.665 1196.58 152.389 1183.3 152.389C1166.53 152.389 1155.16 143.092 1155.16 127.652C1155.16 111.217 1168.11 103.995 1190.52 103.995H1214.76V101.754C1214.76 83.2432 1207.29 74.1953 1189.94 74.1953C1178.4 74.1953 1170.85 79.0098 1164.45 88.3066L1158.4 83.8242C1166.45 72.6182 1175.74 67.1396 1189.94 67.1396ZM1184.63 145.499C1199.48 145.499 1209.61 136.617 1214.76 122.008V110.055H1190.85C1172.17 110.055 1163.21 116.363 1163.21 127.901C1163.21 138.609 1171.1 145.499 1184.63 145.499Z"
        fill="white"
      />
      <path
        d="M1248.05 151.227V68.3018H1255.77V86.8125C1260.17 73.1162 1272.37 67.1396 1282.5 67.1396C1286.81 67.1396 1291.21 68.2188 1294.7 70.46L1291.04 77.0176C1288.06 75.6064 1284.82 74.8594 1281.5 74.8594C1269.88 74.8594 1255.77 83.4922 1255.77 106.485V151.227H1248.05Z"
        fill="white"
      />
      <path
        d="M1334.71 152.389C1310.89 152.389 1297.11 134.542 1297.11 110.221C1297.11 86.1484 1310.47 67.1396 1333.3 67.1396C1359.78 67.1396 1368.41 88.6387 1368.41 104.327C1368.41 106.9 1368.25 110.221 1367.91 111.466H1305.41C1305.91 132.55 1316.78 145.084 1334.71 145.084C1345.5 145.084 1352.47 142.262 1360.53 133.961L1366.09 139.024C1356.62 148.57 1347.83 152.389 1334.71 152.389ZM1305.41 105.489H1360.44C1360.61 103.829 1360.61 101.92 1360.44 100.343C1359.78 88.2236 1352.31 73.9463 1333.22 73.9463C1317.03 73.9463 1306.65 86.8125 1305.41 105.489Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_prod"
          x="13.6446"
          y="85.0977"
          width="53.2441"
          height="53.2441"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4.49215" dy="-4.49215" />
          <feGaussianBlur stdDeviation="2.24608" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_prod" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_prod" result="shape" />
        </filter>
        <filter
          id="filter1_prod"
          x="133.475"
          y="62.6661"
          width="53.1757"
          height="53.1757"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4.49215" dy="-4.49215" />
          <feGaussianBlur stdDeviation="2.24608" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_prod" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_prod" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_prod"
          x1="46.7083"
          y1="0.226562"
          x2="46.7083"
          y2="144.227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA3632" />
          <stop offset="1" stopColor="#800E0C" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
export default GVIconText;
